import clsx from 'clsx';
import { classes } from 'app/chakra-theme/components';
import {
  ColSpanArgs,
  FormatterProps,
  SummaryFormatterProps,
} from 'react-data-grid';
import {
  BodyRow,
  ColumnType,
  HeaderRow,
  RowType,
  SummaryRow,
} from 'app/components/ChakraTableList/types';
import { ListItem } from 'app/components/ChakraTableList/ListItem';
import React from 'react';

interface MappedColumnsArgs {
  columns: ColumnType[];
  formatter: ({
    row,
    column,
    ...props
  }: FormatterProps<BodyRow>) => JSX.Element;
}

const getColSpan = (columns: ColumnType[], column: ColumnType) => (
  props: ColSpanArgs<BodyRow, HeaderRow>
) => {
  if (
    props.type === 'ROW' &&
    props.row.type &&
    [
      RowType.SUBHEADER,
      RowType.SUBHEADER_LOADER,
      RowType.CUSTOM_CONTENT,
    ].includes(props.row.type)
  ) {
    return columns.length;
  }
  if (column.colSpan) {
    return column.colSpan(props);
  }
  return undefined;
};

const getColumnWidth = ({ column }: { column: ColumnType }) => {
  if (column.accessory) {
    return {
      width: 48,
    };
  }
  if (column.contextMenu) {
    return { width: 48 };
  }
  return {};
};

export const MappedColumns = ({ columns, formatter }: MappedColumnsArgs) => {
  const noHeader = !columns.find((column) => column.name !== '');
  return columns.map(({ headerCellClass, ...column }) => {
    const sharedCellClasses = clsx({
      [classes.cell]: !column.contextMenu && !column.accessory,
      [classes.accessoryCell]: column.accessory,
      [classes.rightAlignedCell]: column.alignRight,
    });
    return {
      ...getColumnWidth({ column }),
      headerCellClass: clsx(
        classes.headerCell,
        sharedCellClasses,
        headerCellClass,
        {
          [classes.noHeader]: noHeader,
          [classes.centeredCell]: column.centered,
        }
      ),
      cellClass: sharedCellClasses,
      summaryCellClass: sharedCellClasses,
      colSpan: getColSpan(columns, column),
      formatter,
      summaryFormatter: ({
        row,
        column,
      }: SummaryFormatterProps<SummaryRow>) => (
        <ListItem>{row[column.key]}</ListItem>
      ),
      ...column,
    };
  });
};
